const SLOT_MAP = {
    header: {
        x: 2.50 * 72,
        y: 0.20 * 72,
        w: 7.40 * 72,
        h: 1.7 * 72,
      },
      label: {
        x: 1.00 * 72,
        y: 1.83 * 72,
        w: 3.73 * 72,
        h: 0.05 * 72,
      },
      notationA: {
        x: 1.50 * 72,
        y: 2.51 * 72,
        w: 2.42 * 72,
        h: 2.68 * 72,
      },
      notationB: {
        x: 7.33 * 72,
        y: 2.5 * 72,
        w: 2.89 * 72,
        h: 1.22 * 72,
      },
      notationC: {
        x: 1.76 * 72,
        y: 5.56 * 72,
        w: 7.62 * 72,
        h: 1.34 * 72,
      },
      notationD: {
        x: 1.76 * 72,
        y: 2.30 * 72,
        w: 7.62 * 72,
        h: 1.34 * 72,
      },
};

export default SLOT_MAP